export const getInitialState = (): any => ({
  snowflakeTestConnectionData: {},
  snowflakeTestConnectionStatus: 0
});
